/* REACT PACKAGE IMPORTS */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Container, Spinner } from "react-bootstrap";

/* INTERNAL IMPORTS */
import SessionAssessment from "./SessionAssessment";
import {
  fetchAnswersBySession,
  fetchFlaggedQuestions,
} from "../../Features/Sessions/Actions/SessionsActions";
import { fetchFormattedAssessment } from "../../Features/Assessments/Actions/AssessmentsActions";

export default function SessionStart() {
  const [, setFlaggedQuestions] = useState([]);
  const [sections, setSections] = useState([]);

  const { id } = useParams();
  const sessionId = parseInt(id);
  const dispatch = useDispatch();

  const { questions, formattedSections } = useSelector(
    (store) => store.assessments,
  );
  const { session } = useSelector((store) => store.sessions);

  useEffect(() => {
    const initializeSessionData = async () => {
      try {
        const { exam } = session;
        dispatch(fetchFormattedAssessment(exam.exid)).unwrap();
        dispatch(fetchAnswersBySession(sessionId));
        const flaggedResponse = await dispatch(
          fetchFlaggedQuestions({ esId: sessionId }),
        );
        if (!flaggedResponse.error) {
          setFlaggedQuestions(flaggedResponse.payload.data.flagged);
        }
      } catch (error) {
        console.error("Failed to initialize session data:", error);
      }
    };

    initializeSessionData();
  }, [sessionId, dispatch]);

  if (questions.length === 0) {
    return (
      <Container className="d-flex h-screen justify-content-center align-items-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }
  return (
    <div className="list-group box border-0 mb-2">
      <SessionAssessment sections={formattedSections} questions={questions} />
    </div>
  );
}
